import { getOrderDetail } from 'model/order';

export default store => ({
	path: 'cancel/:tradNo',
	indexRoute: {
		getComponent: (nextState, cb) =>
			require.ensure(
				[],
				require => {
					const component = require('./component').default;
					cb(null, component);
				},
				'OrderCancelATM',
			),
		onEnter: ({ params: { tradNo } }) => {
			store.dispatch(getOrderDetail(tradNo));
		},
	},
});
